import autobind from 'autobind-decorator';
import * as React from 'react';
import { Input } from '@shared/ui-components';

import './material-input-search.scss';

interface Props {
  placeholder?: string;
  initialText?: string;
  onChange?: (value: string) => void;
}

interface State {
  search: string;
}

// TODO: remove it to components/UIKit
export class MaterialInputSearch extends React.Component<Props, State> {
  public static defaultProps: Props = {
    placeholder: 'Search...',
  };

  private timeout: any; // NodeJS.Timer ERROR: TS2322: Type 'number' is not assignable to type 'Timer'.

  constructor(props: Props) {
    super(props);
    this.state = {
      search: props.initialText ? props.initialText : '',
    };
  }

  public render(): JSX.Element {
    return (
      <Input
        text={this.props.placeholder}
        input={{
          value: this.state.search,
          onChange: this.onSearchChange,
        }}
      />
    );
  }

  @autobind
  private onSearchChange(event: any): void {
    this.setState({
      search: event.target.value,
    },            () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(
        () => {
          if (this.props.onChange) {
            this.props.onChange(this.state.search);
          }
        },
        300);
    });
  }
}
